import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57deadb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "用户登录", -1))
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = { class: "other-login-methods" }
const _hoisted_7 = { class: "social-logins" }

import { reactive } from "vue";
import '@arco-design/web-vue/dist/arco.css';
import API from "@/api";
import { userLoginUsingPost } from "@/api/userController";
import { useLoginUserStore } from "@/store/userStore";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserLoginPage',
  setup(__props) {

const loginUserStore = useLoginUserStore();
const router = useRouter();

const form = reactive({
  userAccount: "",
  userPassword: "",
} as API.UserLoginRequest);

/**
 * 提交
 */
const handleSubmit = async () => {
  const res = await userLoginUsingPost(form);
  if (res.data.code === 0) {
    await loginUserStore.fetchLoginUser();
    message.success("登录成功");
    router.push({
      path: "/",
      replace: true,
    });
  } else {
    message.error("登录失败，" + res.data.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_icon_user_add = _resolveComponent("icon-user-add")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_icon_code = _resolveComponent("icon-code")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_icon_qq = _resolveComponent("icon-qq")!
  const _component_icon_wechat = _resolveComponent("icon-wechat")!
  const _component_icon_lark_color = _resolveComponent("icon-lark-color")!
  const _component_icon_github = _resolveComponent("icon-github")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_form, {
      model: form,
      style: { maxWidth: '550px', margin: '0 auto' },
      "auto-label-width": "",
      "label-align": "left",
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_icon_user_add, {
            class: "icon",
            size: "20px"
          }),
          _createVNode(_component_a_form_item, {
            field: "userAccount",
            label: "账号"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                modelValue: form.userAccount,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.userAccount) = $event)),
                class: "input-field",
                placeholder: "请输入账号"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_icon_code, {
            class: "icon",
            size: "20px"
          }),
          _createVNode(_component_a_form_item, {
            field: "userPassword",
            label: "密码",
            tooltip: "密码不小于 8 位"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_password, {
                modelValue: form.userPassword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.userPassword) = $event)),
                class: "input-field",
                placeholder: "请输入密码"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_button, {
                class: "submit-button",
                "html-type": "submit",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 登录 ")
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                class: "register-link",
                href: "/user/register",
                type: "outline"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 新用户注册 ")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, [
            _createTextVNode("或使用以下方式登录: （暂未实现） "),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_button, {
                shape: "circle",
                type: "outline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_icon_qq)
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                shape: "circle",
                type: "outline",
                href: "/user/wxLogin"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_icon_wechat)
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                shape: "circle",
                type: "outline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_icon_lark_color)
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                shape: "circle",
                type: "outline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_icon_github)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})